<template>
  <div class="add-service-data-wrapper">
    <b-card no-body>
      <div class="card-padding">
        <span class="d-block text-medium-black font-size-18">
          Create New Service
        </span>
        <div class="row mt-1">
          <div class="col-12 col-md-5">
            <atom-input
              v-model="serviceDetail.serviceName"
              title="Service Name"
              placeholder="Service name"
              errorMessage="Please enter service name"
              :isAsterisk="true"
              :isError="isErrorAtServiceName"
            ></atom-input>
          </div>
        </div>
      </div>

      <hr class="mb-0" />

      <div class="package-area">
        <div class="package-sidebar card-padding-y aside-shadow">
          <div class="w-100 card-padding-x card-padding-bottom">
            <atom-button button-id="button-add-package" @click="addNewPackage">
              <div
                class="d-flex justify-content-center align-items-center gap-4px"
              >
                <feather-icon icon="PlusIcon" size="16" />
                <span>Add New Package</span>
              </div>
            </atom-button>
          </div>

          <div
            v-if="!currentPackageList.length"
            class="d-flex justify-content-center card-padding-x card-padding-bottom package-empty-aside-wrapper"
          >
            <span class="text-show-new-line text-center">
              No package, Please add first
            </span>
          </div>
          <div v-if="currentPackageList.length" class="package-aside-wrapper">
            <div
              v-for="item in currentPackageList"
              :key="item.packageId"
              class="package-wrapper d-flex justify-content-between"
              :class="{ active: item.isSelected }"
              @click="selectPackage(item.packageId)"
            >
              <div class="d-flex flex-column">
                <div class="d-flex">
                  <span class="d-block font-weight-500">
                    {{ item.packageName.trim() || "New Package" }}</span
                  >
                  <feather-icon
                    v-show="
                      isValidateNewServiceTrigger && !item.packageName.trim()
                    "
                    icon="AlertTriangleIcon"
                    size="16"
                    class="ml-1 error-icon"
                  />
                </div>
                <div class="custom-padding-top-2">
                  <b-badge pill :variant="badgeVariant(item.deprecated)">
                    {{ badgeStatus(item.deprecated) }}
                  </b-badge>
                </div>
              </div>

              <atom-button
                button-id="button-delete-package"
                buttonColor="secondary"
                buttonStyle="flat"
                @click="clickCancelCreatePackage(item.packageId)"
              >
                <feather-icon icon="Trash2Icon" size="16" />
              </atom-button>
            </div>
          </div>
        </div>

        <div class="package-detail">
          <molecule-package
            v-if="isSelectPackage"
            v-model="currentPackageItem"
            :is-validate="isValidateNewServiceTrigger"
          />
        </div>
      </div>

      <hr class="mt-0" />

      <div class="bottom__padding d-flex justify-content-end gap-20px">
        <atom-button
          buttonId="btn__create-service"
          :isDisable="isValidateNewServiceTrigger && isErrorCreateService"
          @click="clickCreateService"
          >Create New Service</atom-button
        >

        <atom-button
          buttonId="btn__cancel-create-service"
          buttonStyle="border"
          buttonColor="secondary"
          class="max-w-200px"
          @click="clickCancelCreateService"
          >Cancel</atom-button
        >
      </div>
    </b-card>

    <molecule-modal-dialog
      modalId="modal-confirm-create-service"
      :isTextCenter="true"
      :textTitle="`Do you want to\ncreate “${serviceDetail.serviceName}” ?`"
      buttonTextLeft="Confirm"
      @clickIconClose="closeModal"
      @clickButtonRight="closeModal"
      @clickButtonLeft="clickConfirmCreateService"
    />

    <molecule-modal-dialog
      modalId="modal-confirm-cancel-create-service"
      :isTextCenter="true"
      :textTitle="`Do you want to leave\nwithout finishing?`"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickIconClose="closeModal"
      @clickButtonRight="closeModal"
      @clickButtonLeft="clickConfirmCancelCreateService"
    />

    <molecule-modal-dialog
      modalId="cancel-create-package"
      :isTextCenter="true"
      :textTitle="`Do you want to remove\npackage?`"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickIconClose="closeModal"
      @clickButtonRight="closeModal"
      @clickButtonLeft="clickConfirmCancelCreatePackage"
    />
  </div>
</template>

<script>
import { BCard, BBadge } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import mixinsValidator from "@/mixins/mixinsValidator"
import MoleculePackage from "@/components/molecules/globalSetting/dataManagement/MoleculePackage.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import { DateTime } from "luxon"

export default {
  name: "OrganismAddServiceData",
  components: {
    BCard,
    BBadge,
    AtomInput,
    AtomButton,
    MoleculePackage,
    MoleculeModalDialog,
  },
  mixins: [mixinsValidator, mixinsObjectHelper],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  emits: ["createNewService"],
  data() {
    return {
      modalId: null,

      currentPackageList: [],

      currentPackageItem: null,

      deletePackageId: null,

      isValidateNewServiceTrigger: false,

      newPackageTemplate: {
        packageId: null,
        packageName: "",
        deprecated: false,
        isSelected: true,
        details: [],
        periods: [],
        options: [],
      },
    }
  },
  computed: {
    serviceDetail: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },

    isSelectPackage() {
      return !!this.currentPackageList.find((item) => item.isSelected === true)
    },

    isErrorCreateService() {
      const packageError = this.currentPackageList?.find((pack) => {
        return this.isEmptyString(pack?.packageName?.trim())
      })

      return (
        this.isEmptyString(this.serviceDetail.serviceName) || !!packageError
      )
    },

    isErrorAtServiceName() {
      return this.isValidateNewServiceTrigger
        ? this.isEmptyString(this.serviceDetail.serviceName)
        : false
    },
  },
  watch: {
    currentPackageItem: {
      deep: true,
      handler() {
        const indexUpdate = this.currentPackageList.findIndex(
          (currentPackage) =>
            currentPackage.packageId === this.currentPackageItem.packageId
        )

        this.currentPackageList[indexUpdate] = this.currentPackageItem
      },
    },
  },
  methods: {
    setNewPackage() {
      this.newPackageTemplate = {
        packageId: `new_package_${DateTime.now()}`,
        packageName: "",
        deprecated: false,
        isSelected: true,
        details: [],
        periods: [],
        options: [],
      }

      return this.deepCopyObject(this.newPackageTemplate)
    },

    addNewPackage() {
      this.currentPackageItem = this.setNewPackage()
      this.currentPackageList.push(this.currentPackageItem)

      this.selectPackage(this.currentPackageItem.packageId)
    },

    selectPackage(packageId) {
      this.currentPackageList = this.currentPackageList.map(
        (currentPackage) => {
          return {
            ...currentPackage,
            isSelected: currentPackage.packageId === packageId,
          }
        }
      )

      this.currentPackageItem = this.currentPackageList.find(
        (item) => item.isSelected === true
      )
    },

    clickResetPackage() {
      const index = this.currentPackageList.findIndex(
        (item) => item.packageId == this.deletePackageId
      )

      this.currentPackageList = this.currentPackageList.toSpliced(index, 1)
    },

    clickCreateService() {
      this.isValidateNewServiceTrigger = true

      if (!this.isErrorCreateService) {
        this.openModal("modal-confirm-create-service")
      }
    },

    clickCancelCreateService() {
      this.openModal("modal-confirm-cancel-create-service")
    },

    clickCancelCreatePackage(packageId) {
      this.deletePackageId = packageId

      this.openModal("cancel-create-package")
    },

    clickConfirmCancelCreatePackage() {
      this.closeModal()
      this.clickResetPackage()
      this.deletePackageId = null
    },

    clickConfirmCreateService() {
      const packages = this.currentPackageList.map((packageItem) => {
        return {
          packageName: packageItem.packageName,
          deprecated: packageItem.deprecated,
          details: packageItem.details.map((item) => {
            return {
              packageItemName: item.period,
              packageSubItem: item.info,
              sequence: item.sequence,
            }
          }),
          periods: packageItem.periods.map((item) => {
            return {
              packagePeriodName: item.period,
              price: item.info,
              sequence: item.sequence,
            }
          }),
          options: packageItem.options.map((item) => {
            return {
              packageOptionName: item.period,
              price: item.info,
              sequence: item.sequence,
            }
          }),
        }
      })
      const serviceDetail = {
        serviceName: this.serviceDetail.serviceName,
        deprecated: this.serviceDetail.deprecated,
        packages,
      }
      this.$emit("createNewService", serviceDetail)
      this.closeModal()
    },

    clickConfirmCancelCreateService() {
      this.closeModal()
      this.$router.push("/global-settings/data-management/service")
    },

    /**
     * ? Modal
     */
    openModal(modalId) {
      this.modalId = modalId
      this.$bvModal.show(this.modalId)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
    },

    /**
     * ? Badge
     */
    badgeVariant(isDeprecated) {
      return isDeprecated ? "light-secondary" : "light-success"
    },

    badgeStatus(isDeprecated) {
      return isDeprecated ? "DEPRECATED" : "ACTIVE"
    },
  },
}
</script>

<style lang="scss" scoped>
.add-service-data-wrapper::v-deep .card {
  overflow: hidden;
}

.aside-shadow {
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.card-padding {
  padding: 1.5rem;
}

.error-icon {
  color: #ea5455;
}

.card-padding-x {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.card-padding-y {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.gap-4px {
  gap: 4px;
}

.text-show-new-line {
  color: #6e6b7b;
  font-size: 12px;
  font-weight: 400;
}

.package-aside-wrapper {
  min-height: 60px;
  max-height: 58vh;
  overflow-y: auto;
}

.package-wrapper {
  min-height: 60px;
  padding: 12px 20px;
  transition: border 0.15s linear;

  &.active {
    background-color: #eeecfd;
    border-left: 4px solid #7367f0;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  &:not(.active):hover {
    cursor: pointer;
    background-color: #f6f6f9;
  }
}

.package-detail {
  min-height: 600px;
  overflow-y: auto;
}

.bottom__padding {
  padding: 20px 21px;
}

.gap-20px {
  gap: 20px;
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .package-area {
    display: grid;
    grid-template-areas: "package-sidebar package-detail";
    grid-template-columns: 25% 75%;
  }

  .package-sidebar {
    grid-area: package-sidebar;
  }

  .package-detail {
    grid-area: package-detail;
  }

  .package-aside-wrapper {
    height: 58vh;
  }
}
</style>
